import Product from "../components/product.js";
import Full from "../components/full.js";
import fetchProductData from "../api/fetchProductData.js";
import isAuthorized from "../helpers/isAuthorized.js";

class Catalog {
  constructor() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    this.state = {};
  }
  init() {
    this.isAuthorized = isAuthorized();
    this.products = [...document.querySelectorAll(".product[data-id]")].map(
      productCard => {
        return new Product(productCard, {
          onOpen: this.showFull.bind(this)
        });
      }
    );

    // Show full card if url has hash
    const hash = location.hash;
    if (hash === "") return;
    const matches = hash.match(/^#product_(\d+)/);
    if (!matches) return;
    const productId = parseInt(matches[1]);
    if (Number.isInteger(productId)) {
      const product = this.products.find(item => item.id == productId);
      if (!product) return;
      if (this.isAuthorized) {
        this.full = new Full({
          id: product.id,
          quantity: 0,
          onBuy: product.buy.bind(product),
          isAuthorized: true
        });
      } else {
        this.full = new Full({
          id: product.id,
          isAuthorized: false
        });
      }
    }
  }
  showFull(product) {
    if (this.isAuthorized) {
      this.full = new Full({
        id: product.id,
        quantity: product.getState().quantity,
        size: product.getState().size,
        onSizeChange: product.setSize.bind(product),
        onQuantityChange: product.setQuantity.bind(product),
        onBuy: product.buy.bind(product),
        isAuthorized: true
      });
    } else {
      this.full = new Full({
        id: product.id,
        isAuthorized: false
      });
    }
  }
}

export default Catalog;



// WEBPACK FOOTER //
// ./src/js/apps/catalog.js